import Vue from 'vue'
import Vuelidate from 'vuelidate'
import App from './App.vue'
import router from './router'
import store from './store'
import './registerServiceWorker'
import VueSelect from 'vue-select'
import VueTimepicker from 'vue2-timepicker'
import VueToastr from 'vue-toastr';
import Tooltip from 'vue-directive-tooltip';
import 'vue-directive-tooltip/dist/vueDirectiveTooltip.css';
import 'vue-select/dist/vue-select.css';


Vue.config.productionTip = false

Vue.use(Vuelidate)
Vue.use(VueToastr)
Vue.use(Tooltip);

Vue.component('v-timepicker',VueTimepicker);
Vue.component("v-select", VueSelect.VueSelect);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
